import { Template, TemplateType } from "@interfaces";

export function buildTemplateDescription(
  template: Template,
): string | undefined {
  switch (template.templateType) {
    case TemplateType.PRESCRIPTION: {
      const details = template.prescriptionDetails;
      if (!details || details.length === 0) return undefined;
      return details
        .map((d) =>
          [d.activePrinciple, d.concentration].filter(Boolean).join(" "),
        )
        .join(", ");
    }
    default:
      throw new Error(
        `buildTemplateDescription not implemented for type: ${template.templateType}`,
      );
  }
}
